import React from 'react'
import { DefaultLayout } from '../../layouts'
import { PageHeader, MainContent } from './components'

const OrganizationStatistic = () => {
  return (
    <DefaultLayout role="official">
      <PageHeader />
      <MainContent />
    </DefaultLayout>
  )
}

export { OrganizationStatistic }